import { useState } from 'react'
import { Button } from '@cannect/new-components/atoms'
import { HISTORY_ACTOR_LABEL } from '@cannect/services/resources/recurrency/constants'
import { formatApiDateTime } from '@cannect/services/resources/recurrency/helpers'
import type { SubscriptionDetail } from '@cannect/services/resources/recurrency/types'
import { subscriptionsCopy } from '../copy'

const PAGE = 10

export const HistoryList = ({ detail }: { detail: SubscriptionDetail }) => {
  const [visible, setVisible] = useState(PAGE)
  const history = detail.history || []

  return (
    <section
      aria-labelledby="sub-history"
      className="flex flex-col gap-4 rounded-xl border border-solid border-neutral-100 bg-white p-4 md:p-6">
      <h2 id="sub-history" className="text-lg font-semibold text-neutral-800">
        {subscriptionsCopy.sections.history}
      </h2>
      {!history.length && <p className="text-sm text-neutral-600">{subscriptionsCopy.historyList.empty}</p>}
      <ul className="flex list-none flex-col gap-3 p-0">
        {history.slice(0, visible).map((entry, index) => (
          <li key={entry.id ?? `${entry.at}-${index}`} className="flex flex-col gap-0.5 text-sm">
            <span className="text-neutral-800">{entry.summary}</span>
            <span className="text-xs text-neutral-600">
              <time dateTime={entry.at}>{formatApiDateTime(entry.at)}</time> ·{' '}
              {HISTORY_ACTOR_LABEL[entry.actor] || entry.actor}
            </span>
          </li>
        ))}
      </ul>
      {history.length > visible && (
        <Button variant="outline_light" size="md" className="self-start" onClick={() => setVisible((v) => v + PAGE)}>
          {subscriptionsCopy.buttons.seeMore}
        </Button>
      )}
    </section>
  )
}
